import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
} from '@angular/core'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser'

@Component({
  selector: 'proxy-voting',
  templateUrl: './proxy-voting.component.html',
  styleUrls: ['./proxy-voting.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProxyVotingComponent implements OnChanges {
  @Input() proxyVotingContent: string = ''

  // Cached sanitized HTML to avoid re-sanitizing on every change detection cycle
  proxyVoting: SafeHtml = ''

  constructor(private readonly sanitizer: DomSanitizer) {}

  ngOnChanges(changes: SimpleChanges) {
    console.log('🟡 [ProxyVoting] ngOnChanges - Input changed')
    if (changes['proxyVotingContent']) {
      console.log('📥 [ProxyVoting] proxyVotingContent changed:')
      console.log(
        '   - Previous value:',
        changes['proxyVotingContent'].previousValue,
      )
      console.log(
        '   - Current value:',
        changes['proxyVotingContent'].currentValue,
      )
      console.log(
        '   - First change:',
        changes['proxyVotingContent'].firstChange,
      )
      console.log('   - Content length:', this.proxyVotingContent?.length || 0)

      // Only sanitize when the input actually changes
      this.proxyVoting = this.sanitizer.bypassSecurityTrustHtml(
        this.proxyVotingContent,
      )
      console.log('✅ [ProxyVoting] Content sanitized and cached')
    }
  }
}
